import React from 'react';
import { useNavigate } from 'react-router';
import Icon from './Icon';

const EditItem = ({ link, width = 200 }) => {
	const navigate = useNavigate();

	return (
		<Icon
			name='edit'
			style={{
				fontSize: '14px',
				color: 'black',
				cursor: 'pointer',
				width: `${width}px`,
			}}
			onClick={() => navigate(link)}
		></Icon>
	);
};

export default EditItem;
